<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="邀请面试"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">


        <el-form-item label="面试职位" prop="job_id"  v-if="showJobSelect">  
          <el-select
              v-model="formData.job_id" placeholder="选择面试职位"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>



        <el-form-item label="面试时间" prop="audit_at" >  
          <el-date-picker
            v-model="formData.audit_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择面试时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="面试地点" prop="address_name">
          <el-input v-model="formData.address_name" @focus="selectPoint" placeholder="选择面试地点" readonly></el-input>
        </el-form-item>

        <el-form-item label="详细地址	" prop="address_detailed" >
          <el-input  type="text" v-model="formData.address_detailed" ></el-input>
        </el-form-item>


        <el-form-item label="联系人	" prop="person_name" >
          <el-input  type="text" v-model="formData.person_name" ></el-input>
        </el-form-item>


        <el-form-item label="联系方式	" prop="person_phone" >
          <el-input  type="number" v-model="formData.person_phone" ></el-input>
        </el-form-item>

        <el-form-item label="是否打卡	" prop="is_report" >
          <el-radio-group v-model="formData.is_report" size="small">
            <el-radio :label="1" border>未打卡</el-radio>
            <el-radio :label="2" border >已打卡</el-radio>
          </el-radio-group>
       </el-form-item>

        <el-form-item label="面试通知" prop="mark">
          <el-input type="textarea" v-model="formData.mark"></el-input>
        </el-form-item>
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>

    <select-point-dialog ref="mapDialog"  @setAddress="setAddress"></select-point-dialog>

  </el-dialog>
</template>

<script>
import selectPointDialog from "@/components/map/select-point-dialog.vue";
import { postInterview} from "@/api/director/enroll/index.js";
import { jobList} from "@/api/director/job/index.js";

export default {
  components: { selectPointDialog},

  data() {
    return {
      visible: false,
      showJobSelect:true,
      jobDataList:[],
      formData: {
        job_id:'',
        lat:"",
        lng:"",
        address_name: "",
        address_detailed:"",//详细地址
        audit_at: "",//面试时间
        is_report:1,//is_report是否打卡 1 未打卡  2 已打卡 默认值 1
        person_name: "",
        person_phone: "",//
        mark:'',//面试通知
        user_app_id:'',
        card:null,
        type:1,//加入的类型 默认不传是1普通 enroll_id  2 直接邀请
        enroll_id:null,
       
      },
       rules: {
        
        user_app_id: [
              {required: true, message: '请选择面试人', trigger: 'blur'}
          ],
          audit_at: [
              {required: true, message: '请选择面试时间', trigger: 'blur'}
          ],
          address: [
              {required: true, message: '请输入面试地点', trigger: 'change'}
          ],
          person_phone: [
              {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          person_name: [
              {required: true, message: '请输入联系人', trigger: 'blur'}
          ]
       }
    };
  },
 
  mounted() {

  },
destroyed(){
  this.handleClose();
},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(user_app_id,job_id,enroll_id) {
      console.log(enroll_id);
      this.visible = true;
      this.formData.enroll_id=enroll_id;
      this.formData.user_app_id=user_app_id;
      this.formData.job_id=job_id;
      if(job_id){
        this.showJobSelect=false;
      }else{
        this.initJobList();
      }
    },

    //职位列表
    initJobList(){
      var that = this;
      jobList({ }).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },

    selectPoint(){
      this.$refs.mapDialog.init();
    },

    setAddress(data){
      console.log(data)
      this.formData.lat=data.lat;
      this.formData.lng=data.lng;
      this.formData.address_name=data.address;
      
    },
    
    submit(){
      var that=this;
      if(this.formData.lat === '' || this.formData.lng === ''){
            this.$message.error('请先选择地址！');
            return;
        }
        if(!this.formData.user_app_id){
            this.$message.error('请先选择面试人！');
            return;
        }

        

      this.$refs["form"].validate((valid) => {
          if (valid) {
            postInterview(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
